module.exports = __webpack_public_path__ + "static/img/checklist_.d2abc77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/antarmuka-user/img/checklist_.png
// module id = 5hWI
// module chunks = 1